import TasksModule from '@modules/TasksModule';
import useTasks from '@modules/TasksModule/hooks/useTasks';
import { Button, Headline } from '@servicetitan/design-system';
import classNames from 'classnames';

type Props = {
  taskId: string;
  show?: boolean;
};

const CustomTaskView = ({ taskId, show = false }: Props) => {
  const { taskById } = useTasks();
  const task = taskById[taskId];

  // in general we should have a task, and we should never need this.
  if (!task) {
    return null;
  }

  const handleCloseTask = () => {
    TasksModule.setTaskComplete(task.id);
  };

  // we are using 'show' here to toggle the 'display' of the component
  // so it doesn't mount/unmount every time it's selected and lose any state
  return (
    <div
      className={classNames('w-100', 'h-100', 'of-y-auto', 'p-x-3', 'p-y-2', {
        'd-n': !show,
      })}
    >
      <Headline size='large' className='m-t-2 m-b-3'>
        {task.displayName}
      </Headline>

      <div>Custom Content</div>
      <div>
        <Button onClick={handleCloseTask}>Close Task</Button>
      </div>
    </div>
  );
};

export default CustomTaskView;
